// extracted by mini-css-extract-plugin
export default {"container":"Invoices_container__u3lmE","title":"Invoices_title__eDs1k","filters":"Invoices_filters__0seI8","pagination":"Invoices_pagination__aPnuc"};